<template>
  <div
    class="form-page__header"
    :class="{ 'form-page__header--shadow': shadow }"
  >
    <header>
      <v-layout align-center justify-start>
        <v-flex xs2 md3>
          <v-btn class="mx-0" icon @click="prevPage">
            <v-icon color="gray-6">arrow_back</v-icon>
          </v-btn>
        </v-flex>

        <v-flex xs8 md6>
          <div class="text--center">
            <h1 class="form-page__header__title">
              {{ $t(`${namespace}.${kind}.header.title`) }}
            </h1>
          </div>
        </v-flex>

        <v-flex xs2 md3>
          <div v-if="singleRegistrationRoute" class="text--right pr-2 hidden-xs-only hidden-sm-only">
            <strong>{{ $t(`${namespace}.${kind}.header.registerOneAtATime`) }}</strong><br>
            <span>
              {{ $t(`${namespace}.${kind}.header.tryIt`) }}
              <router-link
                :to="{
                  name: singleRegistrationRoute,
                  params: {
                    type: 'cadastrar'
                  },
                  query: kind === 'project' ? { modal: true } : null
                }"
                :title="$t(`${namespace}.${kind}.header.singleRegistration`)"
                class="accent--text"
              >
                {{ $t(`${namespace}.${kind}.header.singleRegistration`) }}
              </router-link>
            </span>
          </div>
        </v-flex>
      </v-layout>
    </header>

    <transition name="fade">
      <v-progress-linear
        v-if="status === isLoading"
        class="pa-0 ma-0"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
import { STATUS_IS_LOADING, STATUS_SUCCESS, STATUS_FAILED } from 'utils/constants'
import { hasRole } from 'utils/functions'

export default {
  name: 'Header',
  props: {
    kind: {
      type: String
    },
    status: {
      type: Number
    }
  },
  computed: {
    isLoading: () => STATUS_IS_LOADING,
    isSuccess: () => STATUS_SUCCESS,
    isFailed: () => STATUS_FAILED,
    singleRegistrationRoute () {
      if (this.kind === 'costCenter') {
        return 'CostCenter'
      }

      if (this.kind === 'employee') {
        return 'Employee'
      }

      if (this.kind === 'project') {
        return 'Projects'
      }

      return false
    }
  },
  data () {
    return {
      namespace: 'Views.BulkImportPage',
      shadow: false
    }
  },
  methods: {
    hasRole (group, role) {
      return hasRole(group, role)
    },

    prevPage () {
      this.$router.go(-1)
    },

    handleShadow () {
      this.shadow = window.scrollY > 0
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
